import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class UserCard extends Component {

  static propTypes = {
    user: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.fullName = `${this.props.user.firstName} ${this.props.user.lastName}`;
  }

  trackClick = () => {
    window.analytics.track(
      'Clicked Edit Profile',
      { location: 'account-overview' }
    );
  }

  render() {
    return (
      <div className="user__card">
        <div className="user__card__info">
          <p className="user__card__info__name">{this.fullName}</p>
          <Link
            onClick={this.trackClick}
            className="user__card__info__link"
            to="/account/edit-profile">
            Edit Profile
          </Link>
        </div>
      </div>
    );
  }
}
